import { selectRightDrawerOpen } from '../state/HUDSlice';
import { useSelector } from 'react-redux';

const useRightDrawerOpen = () => useSelector(selectRightDrawerOpen);

export default useRightDrawerOpen;
